<template>
  <div>
    <el-button data-testid="medication-usage-report" class="medication-usage-report" :disabled="disabled" :plain="true" type="primary" size="small" @click="lineListReport()">Medication Report</el-button>
    <ProgressOverlay v-if="inProgress" :progress="progressValue" v-on:progress-cancelled="cancel" title="Report In Progress" />
  </div>
</template>

<script>
import ProgressOverlay from "../ProgressBarOverlay.vue";
import util from "../../util";
import moment from "moment";
import { initLineListReportGenerator } from "../../services/reportClient";

export default {
  name: "medication-usage-report",
  props: ["disabled", "filters", "reportRange"],
  components: {
    ProgressOverlay
  },
  data() {
    return {
      inProgress: false,
      cancelDownload: false,
      progressValue: 0,
      medications: {}
    };
  },
  methods: {
    cancel() {
      this.inProgress = false;
      this.cancelDownload = true;
    },
    mapRecordToData(record) {
      const { client, infectionCase, medicationId, dosage, route, startDate, endDate, daysOfTherapy, provider } = record;
      const { firstName, middleName, lastName } = client;
      const { infectionSite, primaryOrganism, onsetDate } = infectionCase;
      const {filterDateStart, filterDateEnd} = this.reportRange;

      return {
        filterDateStart: moment(filterDateStart).format('YYYY-MM-DD'),
        filterDateEnd: moment(filterDateEnd).format('YYYY-MM-DD'),
        name: `${[firstName, middleName, lastName].filter(Boolean).join(" ")}`,
        infectionSite,
        primaryOrganism,
        onsetDate,
        medication: this.medications[medicationId]?.displayText,
        dosage,
        route,
        startDate,
        endDate,
        daysOfTherapy,
        provider
      };
    },
    async fetchPage(page) {
      const size = 1000;
      return await this.$http
        .post(`${window.CONFIG.treatement_api}/prescriptions/search`, {
          ...(this.filters ?? {}),
          includeInfectionCase: true,
          page,
          size
        })
        .then(response => response.body);
    },
    async lineListReport() {
      this.inProgress = true;
      this.progressValue = 0;
      this.cancelDownload = false;
      let currentPage = 1;
      let hasMore = true;
      let data = [];
      let totalPages = 1;

      while (hasMore) {
        if (this.cancelDownload) {
          break;
        }
        const json = await this.fetchPage(currentPage);
        data = [...data, ...json.content.map(this.mapRecordToData)];
        if (json.totalPages === 0) {
          this.cancelExcelExportProgress = true;
          break;
        }
        totalPages = json.totalPages;
        hasMore = currentPage < totalPages;
        this.progressValue = Math.ceil((currentPage/totalPages) * 100)
        currentPage++;
      }
      this.progressValue = 100;
      this.inProgress = false;
      if (!this.cancelDownload) {
        const { medicationUsage } = this.$configStore.getLineListReports();
        initLineListReportGenerator(medicationUsage, data);
      }
    }
  },
  async created() {
    this.medications = await this.$http
      .get(`${window.CONFIG.treatement_api}/config`)
      .then(resp => resp.json())
      .then(json => [...json.medications, ...json.archivedMedications])
      .then(meds => {
        return util.arrayToObj(meds, "id");
      });
  }
};
</script>

<style scoped></style>
